/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'

const HeaderLocationsMenu: React.FC<any> = (clickCapture) => {
  const navigate = useNavigate()
  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({id}, values)
  interface columnItem {
    id: number
    nasname: string
    shortname: string
    description?: string
    expire?: any
  }

  const storedData = localStorage.getItem('kt-auth-react-v')
  const [columnItems, setColumnItems] = useState<columnItem[]>([])
  // storedData varsa ve uygun bir formatta ise columnItems'ı güncelleyin
  useEffect(() => {
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData)
        setColumnItems(parsedData.data.locations)
      } catch (error) {
        console.error('LocalStorage verisi işlenirken hata oluştu:', error)
      }
    }
  }, [storedData])
  const [filter, setFilter] = useState<string>('') // Filtreleme terimini saklamak için state

  // Filtreleme işlevi
  const filteredItems = columnItems.filter(
    (item) =>
      item.shortname.toLowerCase().includes(filter.toLowerCase()) ||
      item.nasname.toLowerCase().includes(filter.toLowerCase()) ||
      (item.description && item.description.toLowerCase().includes(filter.toLowerCase()))
  )
  // Tıklanan lokasyonu alıp local storage koymak için
  const handleClick = (item: {}) => {
    localStorage.setItem('selectedLocation', JSON.stringify(item))
    navigate(0)
  }

  // input autofocus
  const inputRef = useRef<HTMLInputElement | null>(null)
  useEffect(() => {
    if (inputRef.current !== null) {
      inputRef.current.focus()
    }
  }, [clickCapture])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-100 w-md-350px w-lg-375px'
      data-kt-menu='true'
    >
      {/* TITLE::START */}
      <div className='d-flex flex-column bg-info rounded-top cursor-default px-12'>
        <h3 className='text-white fw-bold mt-10 mb-6'>{t('change_location')}</h3>
        {/* SEARCH BUTTON */}
        <input
          ref={inputRef}
          type='text'
          className='form-control form-control-solid mb-4'
          placeholder={t('search')}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      {/* TITLE::END */}

      {/* BODY */}
      <div className='tab-content'>
        <div className='tab'>
          <div className='scroll-y mh-325px my-5 px-4'>
            {/* ITEM */}
            {filteredItems.map((item) => (
              <div key={item.id}>
                <div
                  onClick={() => handleClick(item)}
                  className={`d-flex row p-8 bg-hover-light rounded ${
                    new Date(item.expire) < new Date() && 'bg-secondary bg-opacity-50'
                  }`}
                >
                  <div className='d-flex w-100 justify-content-between'>
                    <h4 className='fs-6 text-gray-800 fw-bolder'>{item.shortname}</h4>
                    <span className='badge badge-light fs-7'>{item.nasname}</span>
                  </div>
                  <div className='text-gray-400 fs-7'>{item.description}</div>
                </div>
                <div className='separator border-white mt-1'></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* BODY::END */}
    </div>
  )
}

export {HeaderLocationsMenu}
